import { Injectable, EventEmitter, HostListener, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ISliderWebData } from '@app/models/slider.model';
import { FavoriesPipe } from '@app/pipes/favories.pipe';
import { debounceTime } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { UserHelper } from '@helpers/user.helper';

declare let betaluxBr: any;

export interface IOdddsFormatType {
  id: number;
  name: string;
}
@Injectable({
  providedIn: 'root',
})
export class UiHelper {
  oddsFormatTypeData: Array<IOdddsFormatType> = [];
  isMobileView = false;
  favPreMatches = [];
  favPreMatchesListener: EventEmitter<any> = new EventEmitter();
  constructor(private _snackBar: MatSnackBar, public _Router: Router) {
    this.getQuickTipp();
    this.getAcceptOdds();
    this.darkThemeListener.pipe(debounceTime(500)).subscribe(x => {
      this.navbarDarkThemeState = false;
      this.changeTheme(x);
    });
    const a = localStorage.getItem('_FavoritesPreMatch');
    if (a != null) {
      this.favPreMatches = JSON.parse(a);
    }

    this.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }

  dimmerListener: EventEmitter<any> = new EventEmitter();

  showScrollToTopButton = false;
  darkThemeListener: EventEmitter<any> = new EventEmitter();
  navbarDarkThemeState = false;

  quickTippIsActive = true;
  tabSelected = 1;
  hasSearchData = true;
  searchTerm = '';
  leftMenuListener: EventEmitter<any> = new EventEmitter();
  leftMenu = false;
  rightMenuListener: EventEmitter<any> = new EventEmitter();
  rightMenu = false;

  rightAreaListener: EventEmitter<any> = new EventEmitter();
  public isBetSlip = true;
  public isLeftMenu = true;

  isCreditPaymentType = '';

  forgotPassListener: EventEmitter<any> = new EventEmitter();
  forgotPass = false;
  depositCardDimmer = false;
  withdrawCardDimmer = false;
  leftSportsMenuDialogListener: EventEmitter<any> = new EventEmitter();
  leftSportsMenuDialog = false;

  loadingDialogListener: EventEmitter<any> = new EventEmitter();
  loadingDialog = false;

  loadingTicketDialogListener: EventEmitter<any> = new EventEmitter();
  loadingTicketDialog = false;

  consentScreenDialogListener: EventEmitter<any> = new EventEmitter();

  bottomNavbarNavigate = 1;
  bottomNavbarNavigateListener: EventEmitter<any> = new EventEmitter();
  bottomActiveItem;
  windowsWidth = 0;
  windowsHeight = 0;
  windowResized: EventEmitter<any> = new EventEmitter();

  isBirthdateBonus = false;

  documentScrollPX = 0;
  documentScrollListener: EventEmitter<any> = new EventEmitter();

  navbarElemList = [];
  contentElemList = [];
  contentHeight = 0;
  contentHeightListener: EventEmitter<any> = new EventEmitter();

  contentMarginTop = 0;
  contentMarginTopListener: EventEmitter<any> = new EventEmitter();

  currentRoute = '';
  currentRouteListener: EventEmitter<any> = new EventEmitter();

  favTournaments = [];
  favTournamentListener: EventEmitter<any> = new EventEmitter();

  apiServiceAddOddEmitter: EventEmitter<any> = new EventEmitter();

  navbarTitle = {
    s: '',
    isRaw: false,
    show: true,
  };
  navbarTitleListener: EventEmitter<any> = new EventEmitter();

  refreshAppListener: EventEmitter<any> = new EventEmitter();

  selectedSlipDetailListener: EventEmitter<any> = new EventEmitter();
  selectedSlipDetail = 0;
  slips_selectedSlipType = 1;
  slips_selectedYear = 0;
  slips_selectedMonth = 0;
  bookingCode = '';
  userProfileList;
  sportSearchInputActive = false;
  footerIsActive = true;
  leftMenuState = false;
  rightMenuState = false;
  loginDropDownIsOpen = false;
  settingsModalOpen = false;
  settingsDropDownIsOpen = false;
  userDropDownIsOpen = false;
  shopDropDownIsOpen = false;
  tabsMenuIsOpen = false;
  langDropdownIsOpen = false;
  leftMenuIsOpen = false;
  currentTheme = 'theme-light';
  placedBetMessage = false;
  placeBetIsActive = false;

  flagRefreshCurrentSlip = true;
  bonusModalflag = false;

  insicStatus: number;
  showSearchBar = true;

  leftMenuSportSelectedListener: EventEmitter<any> = new EventEmitter();

  isTabActive = true;
  isTabActiveTimeout: any;
  isTabActiveLastChanges: any;
  isTabActiveListener: EventEmitter<any> = new EventEmitter();

  isActiveSignalrConnection = false;
  isActiveSignalrConnectionListener: EventEmitter<any> = new EventEmitter();
  customerSelectedOddFormatTypeId = 1;
  customerSelectedOddFormatObject = [{ id: 1, name: 'Decimal' }];
  // Single = 0 , Multiple = 1, System = 2;
  currentSlipTabSelected: 0 | 1 | 2 = 1;
  currentSlipTabSelectedListener: EventEmitter<any> = new EventEmitter();

  // Bet Slip = 1 , My bets a.k.a Cashout = 2;
  currentSlipHeaderTabSelected = 1;
  currentSlipHeaderTabSelectedListener: EventEmitter<any> = new EventEmitter();

  //#endregion
  // Bottom-Dialog
  bottomDialogState = false;
  bottomDialogStateListener: EventEmitter<any> = new EventEmitter();

  // MatchDetailDialog
  detailDialogState = false;

  // match-detail-dialog
  matchDetailData = { matchId: 0, isLive: false };
  matchDetailDataListener: EventEmitter<any> = new EventEmitter();

  allSportSelectedMenuId = '';

  // current-slip-core
  checkboxAcceptOdds = true;
  customerMyTeamData: any = [];

  viewportConst: { [viewportKey: string]: number } = {
    xs: 1,
    s: 3,
    m: 5,
    l: 7,
    xl: 9,
    xxl: 11,
  };

  responsiveResolution = 0;
  responsiveResolutionListener: EventEmitter<number> = new EventEmitter<number>();

  homeSelectedTab = 'hightlights';
  homeSelectedTabListener: EventEmitter<string> = new EventEmitter<string>();

  // Desktop view
  sliderWebData: Array<ISliderWebData> = [];
  sliderMobileData = [];
  timeSinceLastPlayTicket: string;

  paymentMethodList = [
    {
      id: 'BANK_TRANSFER',
      name: 'bank-transfer',
      footerName: 'bank-transfer',
      free: 'payment.o.no',
      availableWD: true,
      availableD: false,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-3_days',
      min: 10,
      max: 5000,
      type: 'payment.o.instant_bank_transfer',
      withdrawalDescription: 'payment.o.withdrawal.banktransfer',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'Paysafecard',
      name: 'paysafecard',
      footerName: 'paysafecard',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-3_days',
      min: 10,
      max: 5000,
      type: 'payment.o.prepaid_debit_card',
      typeW: 'payment.o.instant_bank_transfer',
      description: 'payment.o.paysafecard',
      description1001: 'payment.o.paysafecard.1001',
      withdrawalDescription: 'payment.o.withdrawal.paysafecard',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'VISA',
      name: 'visa',
      footerName: 'visaFooter',
      footerFormat: 'png',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.credit_card',
      description1001: 'payment.o.visa.1001',
      description: 'payment.o.visa',
      withdrawalDescription: 'payment.o.withdrawal.visa',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'ONLINE_UBERWEISEN',
      name: 'uberweisen',
      footerName: 'uberweisen',
      free: 'payment.o.no',
      availableWD: false,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-3_days',
      min: 10,
      max: 5000,
      type: 'payment.o.instant_bank_transfer',
      description: 'payment.o.uberweisen',
      description1001: 'payment.o.uberweisen.1001',
      withdrawalDescription: 'payment.o.withdrawal.uberweisen',
      isCollapsed: true,
      isAvailableFromFooter: false,
    },
    {
      id: 'PAYPAL',
      name: 'paypal',
      footerName: 'paypalFooter',
      footerFormat: 'png',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.24_hours',
      min: 10,
      max: 5000,
      type: 'payment.o.ewallet',
      description: 'payment.o.paypal',
      description1001: 'payment.o.paypal.1001',
      withdrawalDescription: 'payment.o.withdrawal.paypal',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'MASTERCARD',
      name: 'mastercard',
      footerName: 'mastercard',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.credit_card',
      description: 'payment.o.mastercard',
      description1001: 'payment.o.mastercard.1001',
      withdrawalDescription: 'payment.o.withdrawal.mastercard',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'SKRILL',
      name: 'skrill',
      footerName: 'skrillFooter',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.24_hours',
      min: 10,
      max: 5000,
      type: 'payment.o.ewallet',
      description: 'payment.o.skrill',
      description1001: 'payment.o.skrill.1001',
      withdrawalDescription: 'payment.o.withdrawal.skrill',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    // {
    //   id: 'NETELLER',
    //   name: 'neteller',
    //   footerName: 'neteller',
    //   free: 'payment.o.no',
    //   availableWD: true,
    //   availableD: true,
    //   processTime: 'payment.o.instant',
    //   withdrawalProcessTime: 'payment.o.24_hours',
    //   min: 10,
    //   max: 5000,
    //   type: 'payment.o.ewallet',
    //   description: 'payment.o.neteller',
    //   description1001: 'payment.o.neteller.1001',
    //   withdrawalDescription: 'payment.o.withdrawal.neteller',
    //   isCollapsed: true,
    //   isAvailableFromFooter: true,
    //   availableProject: [],
    // },
    {
      id: 'PAYLADO',
      name: 'paylado',
      footerName: 'payladoFooter',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      withdrawalProcessTime: 'payment.o.24_hours',
      processTime: 'payment.o.instant',
      min: 10,
      max: 5000,
      type: 'payment.o.ewallet',
      description: 'payment.o.paylado',
      description1001: 'payment.o.paylado.1001',
      withdrawalDescription: 'payment.o.withdrawal.paylado',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'TRUSTLY',
      name: 'trustly',
      footerName: 'trustly',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      withdrawalProcessTime: 'payment.o.24_hours',
      processTime: 'payment.o.instant',
      min: 10,
      max: 5000,
      type: 'payment.o.ewallet',
      description: 'payment.o.trustly',
      description1001: 'payment.o.trustly.1001',
      withdrawalDescription: 'payment.o.withdrawal.trustly',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'PAY3000',
      name: 'pay3000',
      footerName: 'pay3000Footer',
      free: 'payment.o.no',
      availableWD: false,
      availableD: false,
      withdrawalProcessTime: 'payment.o.24_hours',
      processTime: 'payment.o.instant',
      min: 10,
      max: 5000,
      type: 'payment.o.ewallet',
      description: 'payment.o.pay3000',
      description1001: 'payment.o.pay3000.1001',
      withdrawalDescription: 'payment.o.withdrawal.pay3000',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'APPLEPAY',
      name: 'applePay',
      footerName: 'applePayFooter',
      footerFormat: 'png',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.applePay',
      description1001: 'payment.o.visa.1001',
      description: 'payment.o.visa',
      withdrawalDescription: 'payment.o.withdrawal.applePay',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [''],
    },
    {
      id: 'GOOGLEPAY',
      name: 'googlepay',
      footerName: 'googlepay',
      footerFormat: 'png',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.googlepay',
      description1001: 'payment.o.visa.1001',
      description: 'payment.o.googlepay',
      withdrawalDescription: 'payment.o.withdrawal.googlepay',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [''],
    },
    {
      id: 'BLIK',
      name: 'blik',
      footerName: 'blikFooter',
      footerFormat: 'png',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.blik',
      description1001: 'payment.o.visa.1001',
      description: 'payment.o.blik',
      withdrawalDescription: 'payment.o.withdrawal.blik',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
    {
      id: 'AUTOPAY',
      name: 'autopay',
      footerName: 'autopayLogo',
      footerFormat: 'svg',
      free: 'payment.o.no',
      availableWD: true,
      availableD: true,
      processTime: 'payment.o.instant',
      withdrawalProcessTime: 'payment.o.1-5_days',
      min: 10,
      max: 5000,
      type: 'payment.o.autopay',
      description1001: 'payment.o.visa.1001',
      description: 'payment.o.blik',
      withdrawalDescription: 'payment.o.withdrawal.blik',
      isCollapsed: true,
      isAvailableFromFooter: true,
      availableProject: [],
    },
  ];
  paymentMethodListListener: EventEmitter<any> = new EventEmitter();
  setResolution(_w: number, _h: number) {
    this.windowsWidth = _w;
    this.windowsHeight = _h;
    const data = {
      w: _w,
      h: _h,
    };
    this.windowResized.emit(data);
  }

  setLeftMenu(): void {
    if (this.leftMenu) {
      this.leftMenuListener.emit(false);
      this.leftMenu = false;
    } else {
      this.leftMenuListener.emit(true);
      this.leftMenu = true;
    }
  }

  setRightMenu(): void {
    if (this.rightMenu) {
      this.rightMenuListener.emit(false);
      this.rightMenu = false;
    } else {
      this.rightMenuListener.emit(true);
      this.rightMenu = true;
    }
  }

  changeStatusRightMenu(value): void {
    this.rightMenu = value;
    this.rightMenuListener.emit(value);
  }

  closeAllMenus() {
    // //console.log('---.closeAllMenus--------------',this.rightMenu);
    this.leftMenuListener.emit(false);
    this.leftMenu = false;
    this.rightMenuListener.emit(false);
    this.rightMenu = false;
    this.leftSportsMenuDialogListener.emit(false);
    this.leftSportsMenuDialog = false;
    this.userDropDownIsOpen = false;
  }

  setBottomNavbarNavigate(e) {
    this.bottomNavbarNavigateListener.emit(e);
    this.bottomNavbarNavigate = e;
  }

  setLeftSportsMenuDialog(e) {
    //// console.log("setLeftSportsMenuDialog",e);
    this.leftSportsMenuDialogListener.emit(e);
    this.leftSportsMenuDialog = e;
  }

  setLoadingDialog(e) {
    this.loadingDialogListener.emit(e);
    this.loadingDialog = e;
  }

  setLoadingTicketDialog(e) {
    this.loadingTicketDialogListener.emit(e);
    this.loadingTicketDialog = e;
  }

  setRefreshApp() {
    this.refreshAppListener.emit(true);
  }

  setDocumentScrollPX(e) {
    this.documentScrollListener.emit(e);
    this.documentScrollPX = e;
  }

  setNavbarElemList(e) {
    this.navbarElemList = e;
  }

  setContentMarginTop(e) {
    this.contentMarginTop = e;
    this.contentMarginTopListener.emit(this.contentMarginTop);
  }

  setCurrentRoute(e) {
    //// console.log(e);
    this.currentRoute = e;
    this.currentRouteListener.emit(e);
  }

  setNavbarTitle(e: string, isRAW?: boolean, isShow = true) {
    this.navbarTitle = {
      s: e,
      isRaw: isRAW,
      show: isShow,
    };
    this.navbarTitleListener.emit(this.navbarTitle);
  }

  fireSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  errorSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, 'X', {
        duration: 5000,
        panelClass: ['snackbar-custom', 'error-snackbar'],
        verticalPosition: 'bottom',
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  successSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, 'X', {
        duration: 5000,
        panelClass: ['snackbar-custom', 'success-snackbar'],
        verticalPosition: 'bottom',
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  warningSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
        panelClass: ['snackbar-custom', 'warning-snackbar'],
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  errorSnackBarWithAction(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
        panelClass: ['snackbar-custom', 'error-snackbar'],
        verticalPosition: 'bottom',
      })
      .onAction()
      .subscribe(x => {
        window.open(navigateString, '_blank');
        // todo Navigate Yapılandırılmalı.
      });
  }

  favTournamentChanged(e) {
    const selectedTournament = this.favTournaments.filter(k => k.tourid.toString() == e.tourid.toString());

    if (selectedTournament.length > 0) {
      // this.favTournaments.splice(selectedTournament, 1);
      this.favTournaments = this.favTournaments.filter(k => k.tourid.toString() != e.tourid.toString());
    } else {
      this.favTournaments.push(e);
    }

    this.favTournamentListener.emit(this.favTournaments);
  }

  reBuildFavoriList(matchItem) {
    const a = localStorage.getItem('_FavoritesPreMatch');
    if (a != null) {
      this.favPreMatches = JSON.parse(a);
    }

    if (this.favPreMatches.filter(i => i.BetradarMatchId === matchItem.BetradarMatchId).length > 0) {
      this.favPreMatches = this.favPreMatches.filter(i => {
        return i.BetradarMatchId === matchItem.BetradarMatchId;
      });
    } else {
      this.favPreMatches.push(matchItem);
    }
    localStorage.setItem('_FavoritesPreMatch', JSON.stringify(this.favPreMatches));

    const x = new FavoriesPipe();
    x.transform(matchItem);

    this.favPreMatchesListener.emit(this.favPreMatches);
  }
  setFooterState(state) {
    this.footerIsActive = state;
  }

  SetRightMenuState(state = '') {
    if (state == 'open') {
      this.dimmerListener.emit({
        status: 'open',
        modalId: 'rightMenuDimmer',
      });
    } else {
      this.dimmerListener.emit({
        status: 'closed',
      });
    }
  }

  p1001SetLeftMenuState(state = '') {
    if (state == 'open') {
      this.dimmerListener.emit({
        status: 'open',
        modalId: 'leftMenuDimmer',
      });
    } else {
      this.dimmerListener.emit({
        status: 'closed',
      });
    }
  }

  getTheme() {
    return this.currentTheme;
  }
  changeTheme(x: string) {
    const bodyElement = document.getElementsByTagName('body');
    const themeState = x || (this.currentTheme === 'theme-light' ? 'theme-dark' : 'theme-light');
    switch (themeState) {
      case 'theme-light':
        this.currentTheme = 'theme-light';
        if (bodyElement && bodyElement.length > 0) {
          bodyElement[0].classList.remove(localStorage.getItem('themeState'));
          bodyElement[0].classList.add('theme-light');
        }
        break;
      case 'theme-dark':
        this.currentTheme = 'theme-dark';
        if (bodyElement && bodyElement.length > 0) {
          bodyElement[0].classList.remove(localStorage.getItem('themeState'));
          bodyElement[0].classList.add('theme-dark');
        }
        break;
      case 'theme-casino':
        this.currentTheme = 'theme-casino';
        if (bodyElement && bodyElement.length > 0) {
          bodyElement[0].classList.remove(localStorage.getItem('themeState'));
          bodyElement[0].classList.add('theme-casino');
        }
        break;
    }
    if (environment.isActiveBRSmallWidget === true || environment.isActiveBRSwipeWidget === true) {
      if (typeof betaluxBr !== 'undefined' && betaluxBr.get('betrecommend')?.setThemeMode) {
        const theme = this.currentTheme === 'theme-dark' ? 'dark' : 'light';
        betaluxBr.get('betrecommend').setThemeMode(theme);
      }
    }

    localStorage.setItem('themeState', this.currentTheme);
  }

  toogleForgotPass() {
    if (this.forgotPass) {
      this.dimmerListener.emit({
        status: 'closed',
      });
    } else {
      this.SetRightMenuState('close');
      this.dimmerListener.emit({
        status: 'open',
        modalId: 'forgotPassDimmer',
      });
    }
  }

  closeDimmer(isSignedIn: any) {
    if (document.getElementById('dimmer') != null) {
      document.getElementById('dimmer').style.position = 'static';
    }
    if (environment.product === 'p1012') {
      if (isSignedIn) {
        this.loginDropDownIsOpen = false;
      }
    } else {
      this.loginDropDownIsOpen = false;
    }
    this.shopDropDownIsOpen = false;
    this.langDropdownIsOpen = false;
    this.leftMenuIsOpen = false;
  }

  loginDropDownOpen() {
    this.loginDropDownIsOpen = !this.loginDropDownIsOpen;
  }

  userDropDownOpen() {
    this.userDropDownIsOpen = !this.userDropDownIsOpen;
    this.dimmerListener.emit({
      status: 'closed',
    });
  }
  openSettingsModal() {
    this.dimmerListener.emit({
      status: 'open',
      modalId: 'oddTypeDimmer',
    });
  }

  langDropdownOpen() {
    this.dimmerListener.emit({
      status: 'open',
      modalId: 'langDimmer',
    });
  }

  //#endregion
  // Bottom-Dialog
  p1001SetBottomDialogState(state = '') {
    this.placedBetMessage = false;
    this.placeBetIsActive = false;
    const element = document.getElementById('bottomDialog');

    if (element === null || element === undefined) {
      return;
    }
    if (state === '') {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else if (state === 'open') {
      this.bottomDialogState = true;
      element.style.top = '47px';
      element.style.height = 'calc(var(--vh) - 108px)';
    } else if (state === 'close') {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    }
    this.bottomDialogStateListener.emit(this.bottomDialogState);
  }

  p1001SetMatchDetailDialog(state = '') {
    //  this.placedBetMessage = false;
    //  this.placeBetIsActive = false;
    const element = document.getElementById('detailDialog');

    if (element === null || element === undefined) {
      return;
    }

    if (state === '') {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else if (state === 'open') {
      this.detailDialogState = true;
      element.style.top = '47px';
      element.style.height = 'calc(var(--vh) - 108px)';
    } else if (state === 'close') {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';

      // Match Detail Dialog içindeki Componentler ( eventdetail - liveeventetail ) Temizleniyor.
      this.setMatchDetailData(0, false);
    } else {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    }
  }

  setSportInputStatus(status) {
    this.sportSearchInputActive = status;
  }

  getQuickTipp() {
    const q = JSON.parse(localStorage.getItem('quickTipp'));
    if (q !== null) {
      this.quickTippIsActive = q;
      return q;
    } else {
      this.setQuickTipp(false);
      return true;
    }
  }

  changeQuickTipp() {
    const q = JSON.parse(localStorage.getItem('quickTipp'));
    if (q !== null) {
      this.setQuickTipp(!q);
    }
  }

  setQuickTipp(value) {
    this.quickTippIsActive = value;
    localStorage.setItem('quickTipp', JSON.stringify(value));
  }

  leftMenuSportSelected(_sportID) {
    this.leftMenuSportSelectedListener.emit(_sportID);
  }

  setInsicStatus(value) {
    this.insicStatus = value;
  }

  setMatchDetailData(matchId = 0, isLive = false) {
    this.matchDetailData = { matchId, isLive };
    this.matchDetailDataListener.emit(this.matchDetailData);
  }

  ScrollToTop() {
    const ismobile = this.windowsWidth < 990 ? true : false;
    const elementList = document.querySelectorAll(ismobile ? '#main-page' : 'navbar');
    if (elementList && elementList.length > 0) {
      const element = elementList[0] as HTMLElement;
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }

  ScrollToId() {
    let scrollcord;
    scrollcord = document.getElementById(this.allSportSelectedMenuId);
    if (scrollcord != null) {
      scrollcord.scrollIntoView({
        // behavior: "smooth",
      });
    }
  }

  // current-slip-core
  getAcceptOdds() {
    const acceptOdds = JSON.parse(localStorage.getItem('acceptOdds'));
    if (acceptOdds == null) {
      localStorage.setItem('acceptOdds', JSON.stringify(true));
      this.checkboxAcceptOdds = true;
    } else {
      this.checkboxAcceptOdds = acceptOdds;
    }
  }

  setAcceptOdds(event: any) {
    // event.checked varsa MatSlideToggleChange event'inden geliyordur.Env. kontrolü olduğu için 2 yapıya da uygun yazıldı.
    const checked = event.checked !== undefined ? event.checked : event.target.checked;
    this.checkboxAcceptOdds = checked;
    localStorage.setItem('acceptOdds', JSON.stringify(checked));
  }

  setIsTabActive(state: boolean, time: number) {
    if (time - this.isTabActiveLastChanges < 5 * 1000) {
      if (this.isTabActive) {
        clearTimeout(this.isTabActiveTimeout);
      }
      this.isTabActiveTimeout = setTimeout(() => {
        this.setIsActiveSignalrConnection(state);
      }, 2000);
    } else {
      this.setIsActiveSignalrConnection(state);
    }
    this.isTabActiveLastChanges = time;
    this.isTabActiveListener.emit(this.isTabActive);
  }

  setIsActiveSignalrConnection(state: boolean): void {
    this.isActiveSignalrConnection = state;
    this.isActiveSignalrConnectionListener.emit(this.isActiveSignalrConnection);
  }

  setCurrentSlipTabSelected(state: 0 | 1 | 2) {
    this.currentSlipTabSelected = state;
    this.currentSlipTabSelectedListener.emit(this.currentSlipTabSelected);
  }

  /**
   * Set Current Header Tab on bet slip & my Bets screen. This is use for desktop version.
   *
   * @param state 1|2 - The first input number
   * @returns void
   */
  setCurrentSlipHeaderTabSelected(state: number) {
    this.currentSlipHeaderTabSelected = state;
    this.currentSlipHeaderTabSelectedListener.emit(this.currentSlipHeaderTabSelected);
  }

  setResponsiveResolution(viewport: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl') {
    console.log('setResponsiveResolution', viewport);
    this.responsiveResolution = this.viewportConst[viewport];
    this.responsiveResolutionListener.emit(this.responsiveResolution);
  }

  isResponsiveRules(viewport: Array<'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'>) {
    return viewport.filter(value => this.responsiveResolution >= this.viewportConst[value]).length > 0;
  }
  selectedFormatType(changes?) {
    localStorage.setItem('oddFormatId', changes);
    this.customerSelectedOddFormatObject = this.oddsFormatTypeData
      .filter(s => s.id.toString() === changes.toString())
      .map((item: any) => ({
        id: item.id,
        name: item.name,
      }));

    this.setRefreshApp();
  }

  setMethodListPaymentComponent(methodList: any) {
    this.paymentMethodList = methodList;
    this.paymentMethodListListener.emit(this.paymentMethodList);
  }

  addMarketToSlip(markets: any[]) {
    this.apiServiceAddOddEmitter.emit(markets);
  }

  openBrSwipeWidget(selectedLang = 'en') {
    if (typeof betaluxBr !== 'undefined') {
      betaluxBr &&
        betaluxBr.init('betrecommend-swipe', 'widgetContainer', {
          language: selectedLang,
          apiKey: environment.bRSwipeWidgetApiKey,
        });
      betaluxBr.get('betrecommend-swipe').setLanguage(selectedLang);
      betaluxBr.on('betrecommend-swipe', 'addMarketToSlip', events => {
        this.p1001SetBottomDialogState('open');
        this.addMarketToSlip(events);
      });
    }
  }
  registerShow() {
    const element = document.querySelector('.full-screen-login') as HTMLElement;
    if (element && environment.IsRegisterActive) {
      element.style.display = 'none';
    }
  }
  registerSecret() {
    const element = document.querySelector('.full-screen-login') as HTMLElement;
    element.style.display = 'flex';
  }
}
